/************************************************************************
** IBM Confidential
**
** IBM Business Analytics: Rapidly Adaptive Visualization Engine
**
** (C) Copyright IBM Corp. 2017, 2018
**
** The source code for this program is not published or otherwise divested of its trade secrets, 
** irrespective of what has been deposited with the U.S. Copyright Office.
************************************************************************/
export default class CaseInsensitiveMap 
{
	_map = {};
	_nullValue = null;
	
	put(k, v)
	{
		var keyExist;
		if (!k) {
			keyExist = this._nullValue ? true : false;
			this._nullValue = v;
		} else {
			var lowerCaseKey = k.toLowerCase();
			keyExist = this._map.hasOwnProperty(lowerCaseKey);
			this._map[lowerCaseKey] = v;
		}
		return !keyExist;
	}
	
	containsKey(k)
	{
		if (!k) {
			return this._nullValue;
		}
		return this._map.hasOwnProperty(k.toLowerCase());
	}
}


// WEBPACK FOOTER //
// ./src/generated/CaseInsensitiveMap.js